if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.productMediaModalContent = this.querySelector('.product-media-modal__content');
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this.handleKeyDown);
      }

      handleKeyDown(event) {
        if (event.code === 'ArrowUp') {
          this.productMediaModalContent.scrollBy(0, -50);
        } else if (event.code === 'ArrowDown') {
          this.productMediaModalContent.scrollBy(0, 50);
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        if (this.productMediaModalContent) {
          this.productMediaModalContent.setAttribute('tabindex', '0');
          document.addEventListener('keydown', this.handleKeyDown.bind(this));
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
